import { z, ZodType } from 'zod';
import { jFileLittle, jFileLittleSchema } from '../file';
import { WidgetsName, WidgetType } from './common';
import { zObject } from '../../util/zod';

export type WidgetArticleAttachmentContent = {
    files?: jFileLittle[];
    fileDisplay?: 'list' | 'gallery';
};
export const widgetArticleAttachmentContentSchema = zObject<WidgetArticleAttachmentContent>({
    files: jFileLittleSchema.array().optional(),
    fileDisplay: z.enum(['list', 'gallery']).optional(),
});

export type WidgetArticleAttachmentType = {
    name: WidgetsName.ArticleAttachment;
    uniqid: string;
    content: WidgetArticleAttachmentContent;
};
export const widgetArticleAttachmentTypeSchema = zObject<WidgetArticleAttachmentType>({
    name: z.literal(WidgetsName.ArticleAttachment),
    uniqid: z.string(),
    content: widgetArticleAttachmentContentSchema,
}) satisfies ZodType<WidgetType<WidgetArticleAttachmentContent>>;
